"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
exports.default = (0, mobx_react_1.observer)(({ field, type = 'text', placeholder = null, validatingText = 'validating...', }) => (react_1.default.createElement("div", { className: "pv3" },
    react_1.default.createElement(TextField_1.default, Object.assign({}, field.bind({ type, placeholder, validatingText }), { variant: "standard", fullWidth: true })),
    react_1.default.createElement("br", null))));
